import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as TalkCommentAPI from "@/api/talk-comment";
import { CommonResponse, isSuccess } from "@/api/response";
import { PostRequest } from "@/api/talk-comment/request";

const MODULE_NAME = "talk-comment/post";

/**
 * コメント送信APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Post extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  @MutationAction
  async post(postRequest: PostRequest) {
    const commonResponse = await TalkCommentAPI.post(postRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Post);
